export type PictureTextType = "Grid" | "Slider" | "unknown";

export const TRACKING_PROMO_TYPE = "ImagePromotion";

export type TrackingWidgetTile = {
    id: string
    position: number
    labels: { [key: string]: string[] }
}